<template>
    <v-content>
        <layout-page-info title="Уважаемые участники исследования!">
            <div class="generate__description" v-html="config.content"></div>

            <v-select :items="respondents" label=" Выберите категорию тестирования" solo v-model="respondent" class="mb-4" @input="resetSteps"></v-select>

            <template v-if="showSteps">
                <item-test v-for="item in filteredSteps" :key="item.stage"
                        :title="item.title"
                        :description="item.description"
                        v-model="test[item.stage]">
                </item-test>
            </template>

            <template slot="btn">
                <v-btn v-if="showBtn" @click="onSubmit" class="generate-item__btn" large color="success">Начать тестирование</v-btn>
            </template>
        </layout-page-info>
    </v-content>
</template>

<script>
    import {mapState} from 'vuex'
    import Vue from 'vue'
    import LayoutPageInfo from '@/components/layouts/page-info'
    import ItemTest from './item'
    import config from './config.json'

    export default {
        components: {
            LayoutPageInfo,
            ItemTest
        },
        data () {
            return {
                test: {},
                respondent: '',
                respondents: [
                    {text: 'Работник', value: 'worker'},
                    {text: 'Студент', value: 'student'},
                    {text: 'Менеджер / Работодатель', value: 'employer'}
                ]
            }
        },
        computed: {
            ...mapState('testing', ['steps']),
            showBtn () {
                return Object.keys(this.test).some(key => this.test[key])
            },
            config () {
                return config
            },
            showSteps () {
                return !!this.respondent
            },
            filteredSteps () {
                if (this.respondent === 'employer') {
                    let stage1 = this.config.steps[0]
                    let config = [{
                        stage: stage1.stage,
                        title: stage1.title,
                        description: 'В настоящем разделе производится оценка применения в компании практик повышения производительности труда'
                    }]
                    return config
                }
                else return this.config.steps
            }
        },
        methods: {
            init () {
                if (this.steps.length) {
                    this.next()
                } else {
                    this.config.steps.forEach(({stage}) => Vue.set(this.test, stage, false))
                }
            },
            onSubmit () {
                let stages = Object.keys(this.test)
                    .map(stage => (this.test[stage] && stage))
                    .filter(step => !!step)

                this.$store.dispatch('profile/updateStages', {stages, respondent: this.respondent})
                this.next()
            },
            next () {
                this.$store.dispatch('session/push', 'hello')
            },
            resetSteps () {
                Object.keys(this.test).forEach(key => (this.test[key] = false))
            }
        },
        created () {
            this.init()
        }
    }
</script>

<style lang="stylus">
    .generate {
        &__description {
            font-size 1.4rem
            margin-bottom 3rem
        }
    }
</style>
